import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { CreateCardFromTemplatePopoverProps } from './CreateCardFromTemplatePopover';

export const LazyCreateCardFromTemplatePopover: FunctionComponent<
  CreateCardFromTemplatePopoverProps
> = (props) => {
  const CreateCardFromTemplatePopover = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "card-templates" */ './CreateCardFromTemplatePopover'
      ),
    { namedImport: 'CreateCardFromTemplatePopover' },
  );

  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-aaaa', feature: 'Card Templates' }}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <CreateCardFromTemplatePopover {...props} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
